import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=45d09afc&scoped=true&"
import script from "./testimonial.vue?vue&type=script&lang=ts&"
export * from "./testimonial.vue?vue&type=script&lang=ts&"
import style0 from "./testimonial.vue?vue&type=style&index=0&id=45d09afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d09afc",
  null
  
)

export default component.exports